import { FetchResult, useMutation } from '@apollo/client';
import { Goal } from '../../goals';
import {
    CreateGoalAccountOnboardingDocument,
    UpdateGoalAccountOnboardingDocument,
    UpdateGoalAccountOnboardingMutation,
    UpdateGoalAccountOnboardingMutationVariables,
} from '../../graphql/generated';
import { DefaultGoalAccountOnboardingInfo } from '../../types';
import { getMyGoalAccountOnboarding } from './helpers';

export type UpsertMyGoalAccountOnboardingParams = Partial<{
    confirmedAt: UpdateGoalAccountOnboardingMutationVariables['confirmedAt'];
    info: Partial<DefaultGoalAccountOnboardingInfo>;
}>;

type UpsertMyGoalAccountOnboardingFcn = (
    params: UpsertMyGoalAccountOnboardingParams
) => Promise<FetchResult<UpdateGoalAccountOnboardingMutation>>;

export const useUpsertMyGoalAccountOnboarding = (goal: Goal) => {
    const [createGoalAccountOnboarding] = useMutation(
        CreateGoalAccountOnboardingDocument
    );
    const [updateGoalAccountOnboarding] = useMutation(
        UpdateGoalAccountOnboardingDocument
    );
    const upsertMyGoalAccountOnboarding: UpsertMyGoalAccountOnboardingFcn =
        async ({ info, confirmedAt }) => {
            const onboarding = getMyGoalAccountOnboarding(goal);
            if (!onboarding) {
                // Account onboarding hasn't been created; create it.
                return createGoalAccountOnboarding({
                    variables: {
                        info: {
                            ...(info ?? {}),
                            infoType: 'DEFAULT',
                        },
                        goalId: goal.id,
                    },
                });
            } else {
                // Update existing onboarding
                return updateGoalAccountOnboarding({
                    variables: {
                        id: onboarding.id,
                        confirmedAt,
                        info: { ...onboarding.info, ...(info ?? {}) },
                    },
                });
            }
        };
    return upsertMyGoalAccountOnboarding;
};
